// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetApiV3Time (params?: {}): Promise<implicitReturnType>;
    publicGetApiV3Coins (params?: {}): Promise<implicitReturnType>;
    publicGetApiV3ExchangeInfo (params?: {}): Promise<implicitReturnType>;
    publicGetApiV3Ping (params?: {}): Promise<implicitReturnType>;
    publicGetApiV3ApiTradingSymbols (params?: {}): Promise<implicitReturnType>;
    publicGetApiV3MarketTickerPrice (params?: {}): Promise<implicitReturnType>;
    publicGetApiV3MarketTicker24hr (params?: {}): Promise<implicitReturnType>;
    publicGetApiV3MarketTrades (params?: {}): Promise<implicitReturnType>;
    publicGetApiV3MarketKlines (params?: {}): Promise<implicitReturnType>;
    publicGetApiV3MarketDepth (params?: {}): Promise<implicitReturnType>;
    publicGetApiV3MarketTickerBookTicker (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3Account (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3AccountTransferRecords (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3Order (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3OpenOrders (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3AllOrders (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3MyTrades (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3RebateAffiliateGetAffiliateUIDs (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3RebateAffiliateGetChannelUserTradeAndAsset (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3RebateAffiliateGetAffiliateCommission (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3RebateAffiliateGetInternalWithdrawalStatus (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3RebateAffiliateQuerySubChannelTransactions (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3AgencyVerifyReferrals (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3AgencyGetAssert (params?: {}): Promise<implicitReturnType>;
    privateGetApiV3AgencyGetDealData (params?: {}): Promise<implicitReturnType>;
    privatePostApiV3AccountBills (params?: {}): Promise<implicitReturnType>;
    privatePostApiV3AccountFundingBills (params?: {}): Promise<implicitReturnType>;
    privatePostApiV3Order (params?: {}): Promise<implicitReturnType>;
    privatePostApiV3OrderBatch (params?: {}): Promise<implicitReturnType>;
    privatePostApiV3RebateAffiliateInternalWithdrawal (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV3Order (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV3OpenOrders (params?: {}): Promise<implicitReturnType>;
    privateDeleteApiV3OrderBatch (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketTime (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketExchangeInfo (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketDepth (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketTicker24hr (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketTickerBookTicker (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketTrades (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketKlines (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketIndexPriceKlines (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketMarkPriceKlines (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketHistoryKlines (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketSymbolPrice (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketOpenInterest (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketPremiumIndex (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketFundingRate (params?: {}): Promise<implicitReturnType>;
    contractGetCapiV3MarketApiTradingSymbols (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3AccountBalance (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3AccountCommissionRate (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3AccountAccountConfig (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3AccountSymbolConfig (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3AccountPositionAllPosition (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3AccountPositionSinglePosition (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3Order (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3OpenOrders (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3OrderHistory (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3UserTrades (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3OpenAlgoOrders (params?: {}): Promise<implicitReturnType>;
    contractPrivateGetCapiV3AllAlgoOrders (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3AccountIncome (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3AccountMarginType (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3AccountLeverage (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3AccountPositionMargin (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3AccountModifyAutoAppendMargin (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3Order (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3BatchOrders (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3ClosePositions (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3AlgoOrder (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3PlaceTpSlOrder (params?: {}): Promise<implicitReturnType>;
    contractPrivatePostCapiV3ModifyTpSlOrder (params?: {}): Promise<implicitReturnType>;
    contractPrivateDeleteCapiV3Order (params?: {}): Promise<implicitReturnType>;
    contractPrivateDeleteCapiV3BatchOrders (params?: {}): Promise<implicitReturnType>;
    contractPrivateDeleteCapiV3AllOpenOrders (params?: {}): Promise<implicitReturnType>;
    contractPrivateDeleteCapiV3AlgoOrder (params?: {}): Promise<implicitReturnType>;
    contractPrivateDeleteCapiV3AlgoOpenOrders (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
